import { trackBehaviorEvent } from "@/utils/behaviorTracker";
import { resolvePageKeyFromPath } from "./routeMap";

let currentPage = null;
let currentPageKey = null;
let pageEnterTime = 0;

export function trackPageView(pagePath, pageKeyOverride) {
  const pageKey = pageKeyOverride || resolvePageKeyFromPath(pagePath);
  if (!pageKey) return null;
  currentPage = pagePath;
  currentPageKey = pageKey;
  pageEnterTime = Date.now();
  return trackBehaviorEvent("page_view", {
    page: pagePath,
    properties: { page_key: pageKey },
  });
}

export function trackPageLeave(pagePath, pageKeyOverride) {
  const pageKey = pageKeyOverride || currentPageKey || resolvePageKeyFromPath(pagePath);
  if (!pageKey) return null;
  const durationMs = pageEnterTime ? Math.max(0, Date.now() - pageEnterTime) : 0;
  return trackBehaviorEvent("page_leave", {
    page: pagePath || currentPage || "",
    properties: {
      page_key: pageKey,
      duration_ms: durationMs,
    },
  });
}

/** 路由切换：上一页 leave + 新页 view */
export function trackRouteChange(nextPath, prevPath) {
  if (prevPath && prevPath !== nextPath) {
    trackPageLeave(prevPath);
  }
  return trackPageView(nextPath);
}

export function trackButtonClick({ buttonId, feature, pagePath, pageKey }) {
  return safeTrack("button_click", {
    page: pagePath || "",
    properties: {
      button_id: buttonId,
      feature,
      ...(pageKey ? { page_key: pageKey } : {}),
    },
  });
}

export function trackFeatureUse({ feature, action, pagePath, pageKey, extra = {} }) {
  return trackBehaviorEvent("feature_use", {
    page: pagePath || "",
    properties: {
      feature,
      action,
      ...(pageKey ? { page_key: pageKey } : {}),
      ...extra,
    },
  });
}

/** 安全上报：spec 未就绪时不阻断业务 */
export function safeTrack(eventName, payload) {
  try {
    return trackBehaviorEvent(eventName, payload);
  } catch (err) {
    if (process.env.NODE_ENV !== "production") {
      console.warn("[clientBehavior]", eventName, err.message);
    }
    return null;
  }
}

export default {
  trackPageView,
  trackPageLeave,
  trackRouteChange,
  trackButtonClick,
  trackFeatureUse,
  safeTrack,
};
